module.exports = __webpack_public_path__ + "fonts/baronsans-extralightitalic-webfont.a5dd7fa2.woff";